<template>
  <v-layout row wrap v-show="show">
    <slot></slot>
  </v-layout>
</template>
<script>
import {EventMixin} from '@/lib/mixins.js';
export default {
  mixins: [EventMixin],
  props: [
    'value'
  ]
}
</script>
